<template>
  <button
    class="quick-add-button"
    :class="[
      { 'quick-add-button--sizes-shown': sizesAreShown },
      modifier ? `quick-add-button--${modifier}` : '',
    ]"
  >
    <span v-if="isIconVisible" class="quick-add-button__plus icon-plus"></span>
    <span class="quick-add-button__text">{{ buttonText }}</span>
  </button>
</template>

<script>
export const MODIFIER = {
  default: '',
  uppercase: 'uppercase',
  round: 'round',
}

export default {
  name: 'QuickAddButton',

  props: {
    sizesAreShown: { type: Boolean, default: false },
    buttonText: { type: String, default: '' },
    isIconVisible: { type: Boolean, default: true },
    modifier: {
      type: String,
      default: MODIFIER.default,
      validator(value) {
        return Object.values(MODIFIER).includes(value)
      },
    },
  },
}
</script>

<style lang="scss" scoped>
.quick-add-button {
  position: relative;
  z-index: 2;
  width: 100%;
  height: 48px;
  font-size: 15px;
  line-height: 1;
  color: $color-grey-dark-2;
  background-color: rgba($color-white, 0.85);
  transition: opacity $transition-time;
  transition-delay: 0.25s;

  &--sizes-shown & {
    z-index: 0;
    opacity: 0;
    transition-delay: 0s;
  }

  &--uppercase {
    text-transform: uppercase;
  }

  &--round {
    width: 45px;
    height: 45px;
    border-radius: 100%;

    &--sizes-shown {
      opacity: 0;
      transition: none;
    }
  }

  &__plus {
    position: relative;
    right: -1px;
    font-size: $font-size-xsmall;
    color: $color-grey-dark-2;

    .quick-add-button--round & {
      top: 1px;
      margin: 0;
    }
  }

  &__text {
    position: relative;
    top: 1px;
  }
}
</style>
